// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._16jlkb7n{flex-grow:1}\n._1e0c1txw{display:flex}\n._1o9zkb7n{flex-shrink:1}\n._2lx21bp4{flex-direction:column}\n._4t3iidpf{height:0}\n._i0dl1wug{flex-basis:auto}", ""]);
// Exports
module.exports = exports;
